
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$layout.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$layout.js';
export default __default__;
